import { type HttpStatusCode } from 'axios';

import type { Call, CallCampaign, Group, Model } from '~/types/models';

export interface AttachResponse {
  attached: number;
  skipped: number;
}

export interface DetachResponse {
  detached: number;
  skipped: number;
}

export interface ErrorResponse<T = Model> {
  status: HttpStatusCode;
  message: string | null;
  code: string | null;
  errors?: Record<keyof T, string[]>;
}
export function isErrorResponse(r: any): r is ErrorResponse {
  return (
    !!r &&
    (typeof r.message === 'string' || r.message !== undefined) &&
    (typeof r.code === 'string' || r.code !== undefined)
  );
}

export interface ImportResponse {
  created: number;
  updated: number;
  skipped: number;
  log: Record<string, string>;
}

export interface IndexResponse<T> {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  total: number;
  items: T[];
}

export interface PointageInitResponse {
  call: Call | null;
  campaigns: CallCampaign[];
  groups: Group[];
}

export interface SendUnsentEmailsResponse {
  sent: number;
}

export interface SendUnsentSmsResponse {
  sent: number;
}

export interface UploadedFileResponse {
  fileName: string;
  mimeType: string;
  headers: string[];
  sampleData: string[][];
  length: number;
}
export function isUploadedFileResponse(r: any): r is UploadedFileResponse {
  return !!r && typeof r.fileName === 'string' && typeof r.mimeType === 'string';
}
